import script from "./allByTopic.vue?vue&type=script&lang=ts&setup=true"
export * from "./allByTopic.vue?vue&type=script&lang=ts&setup=true"

import "./allByTopic.vue?vue&type=style&index=0&id=42cec29b&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42cec29b"]])

export default __exports__